import { useContext } from 'react';
import { ActiveCatalogContext } from '../contexts/ActiveCatalogContext';

export const useActiveCatalog = () => {
  const context = useContext(ActiveCatalogContext);
  if (!context) {
    throw new Error('useActiveCatalog must be used within ActiveCatalogProvider');
  }
  return context;
};
